function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"])
    return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r))
    return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var _n = 0, F = function F() { };
        return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
} var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try {
        a || null == t["return"] || t["return"]();
    }
    finally {
        if (u)
            throw o;
    } } }; }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
import { useState, useEffect } from 'react';
import { NotificationAPI } from '@/apis/NotificationAPI';
import { ConfigurationAPI } from '@/apis/ConfigurationAPI';
import { getUserFromCookie } from '@/utils/utilities';
import { EXPERIENCE_ACTIONS } from '@/utils/permissionGateConfig';
import { getPoliciesFromSession } from '@/components/PermissionGate';
var SURVEY_NOTIFICATION_INTERVAL_DAYS = 15;
var MS_PER_DAY = 1000 * 60 * 60 * 24;
var REQUIRED_ACTIONS = [EXPERIENCE_ACTIONS.EXPERIENCE_CREATE_SURVEY_RESPONSE, EXPERIENCE_ACTIONS.EXPERIENCE_VIEW_SURVEY_RESPONSE];
// Check if the given date is more than specified days ago
var isMoreThanDaysAgo = function isMoreThanDaysAgo(dateString, days) {
    var diffTime = Date.now() - new Date(dateString).getTime();
    return diffTime / MS_PER_DAY > days;
};
// Check if user has all required actions in their policies
var hasRequiredActions = function hasRequiredActions(policies) {
    if (!policies || policies.length === 0)
        return false;
    // Collect all actions from all policies' resource_action arrays
    var allActions = [];
    var _iterator = _createForOfIteratorHelper(policies), _step;
    try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _policy$resource_acti;
            var policy = _step.value;
            var resourceActions = (_policy$resource_acti = policy === null || policy === void 0 ? void 0 : policy.resource_action) !== null && _policy$resource_acti !== void 0 ? _policy$resource_acti : [];
            var _iterator2 = _createForOfIteratorHelper(resourceActions), _step2;
            try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    var _ra$action;
                    var ra = _step2.value;
                    var actions = (_ra$action = ra === null || ra === void 0 ? void 0 : ra.action) !== null && _ra$action !== void 0 ? _ra$action : [];
                    allActions.push.apply(allActions, _toConsumableArray(actions));
                }
            }
            catch (err) {
                _iterator2.e(err);
            }
            finally {
                _iterator2.f();
            }
        }
        // Check if all required actions are present
    }
    catch (err) {
        _iterator.e(err);
    }
    finally {
        _iterator.f();
    }
    return REQUIRED_ACTIONS.every(function (action) {
        return allActions.includes(action);
    });
};
// Determine if survey notification should be shown based on last response
var shouldShowBasedOnLastResponse = function shouldShowBasedOnLastResponse(lastUpdated) {
    if (!lastUpdated)
        return true;
    return isMoreThanDaysAgo(lastUpdated, SURVEY_NOTIFICATION_INTERVAL_DAYS);
};
/**
 * Hook to determine if the survey notification should be shown to the user.
 *
 * Logic:
 * 1. Get user's policies from session storage and check if user has required actions
 * 2. If authorized, fetch the user's last survey response date
 * 3. If no survey exists OR last survey was more than 15 days ago, return true
 *
 * @returns Object containing shouldShowSurveyNotification boolean and isSurveyLoading
 */
export var useSurveyNotification = function useSurveyNotification() {
    var _useState = useState(false), _useState2 = _slicedToArray(_useState, 2), shouldShowSurveyNotification = _useState2[0], setShouldShowSurveyNotification = _useState2[1];
    var _useState3 = useState(true), _useState4 = _slicedToArray(_useState3, 2), isSurveyLoading = _useState4[0], setIsSurveyLoading = _useState4[1];
    useEffect(function () {
        var checkSurveyNotification = /*#__PURE__*/ function () {
            var _ref = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee() {
                var _getUserFromCookie;
                var userId, policies, platformHost, _yield$NotificationAP, lastUpdated, _t;
                return _regenerator().w(function (_context) {
                    while (1)
                        switch (_context.p = _context.n) {
                            case 0:
                                userId = (_getUserFromCookie = getUserFromCookie()) === null || _getUserFromCookie === void 0 ? void 0 : _getUserFromCookie.id;
                                if (userId) {
                                    _context.n = 1;
                                    break;
                                }
                                setIsSurveyLoading(false);
                                return _context.a(2);
                            case 1:
                                _context.p = 1;
                                // Get policies from session storage using shared utility
                                policies = getPoliciesFromSession();
                                if (hasRequiredActions(policies)) {
                                    _context.n = 2;
                                    break;
                                }
                                setIsSurveyLoading(false);
                                return _context.a(2);
                            case 2:
                                _context.n = 3;
                                return ConfigurationAPI.getPlatformHost();
                            case 3:
                                platformHost = _context.v;
                                _context.n = 4;
                                return NotificationAPI.getLastSurveyResponse(userId, platformHost);
                            case 4:
                                _yield$NotificationAP = _context.v;
                                lastUpdated = _yield$NotificationAP.lastUpdated;
                                setShouldShowSurveyNotification(shouldShowBasedOnLastResponse(lastUpdated));
                                _context.n = 6;
                                break;
                            case 5:
                                _context.p = 5;
                                _t = _context.v;
                                console.error('Error checking survey notification eligibility:', _t);
                            case 6:
                                _context.p = 6;
                                setIsSurveyLoading(false);
                                return _context.f(6);
                            case 7:
                                return _context.a(2);
                        }
                }, _callee, null, [[1, 5, 6, 7]]);
            }));
            return function checkSurveyNotification() {
                return _ref.apply(this, arguments);
            };
        }();
        checkSurveyNotification();
    }, []);
    return {
        shouldShowSurveyNotification: shouldShowSurveyNotification,
        isSurveyLoading: isSurveyLoading
    };
};
